import {ErrorPriority} from "../../enums/ErrorPriority"
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";
import {ErrorLog} from "./ErrorLog";
import {LoggableEntity} from "./LoggableEntity";

export abstract class BaseError extends LoggableEntity {
    errorLogs?: ErrorLog[];
    mostRecentOccurred: Date;
    occurrenceCount: number;
    solution?: string;

    constructor(id: string, tenant: Tenant, application: TenantApplication, mostRecentOccurred: Date | string, occurrenceCount: number,
                errorType: ErrorPriority, isSolved: boolean, errorlogs?: ErrorLog[], solution?: string) {
        super(id, tenant, application, errorType, isSolved);
        this.errorLogs = errorlogs;
        this.mostRecentOccurred = new Date(mostRecentOccurred);
        this.occurrenceCount = occurrenceCount;
        this.solution = solution;
    }

    public get mostRecentOccurredAsString(): string {
        return this.mostRecentOccurred.toLocaleString();
    }

    public getSummarizedContent(maxLenght: number): string {
        const content = this.getContentForSummary();
        return content.length > maxLenght ? content.substring(0, maxLenght) + "..." : content;
    }

    protected abstract getContentForSummary(): string;
}
